module.exports = __webpack_public_path__ + "static/scale-model-of-albuquerque-museum-in-albuquerque-new-mexico-4d5caa2e6674b97fad7a30b6a2f9c4d5.png";